"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var core_tenant_service_1 = require("app/main/content/_service/core-tenant.service");
var login_service_1 = require("app/main/content/_service/login.service");
var user_1 = require("app/main/content/_model/user");
var core_user_service_1 = require("app/main/content/_service/core-user.service");
var role_change_service_1 = require("app/main/content/_service/role-change.service");
var TenantOverviewComponent = /** @class */ (function () {
    function TenantOverviewComponent(loginService, tenantService, coreUserService, roleChangeService) {
        this.loginService = loginService;
        this.tenantService = tenantService;
        this.coreUserService = coreUserService;
        this.roleChangeService = roleChangeService;
        this.currentTenants = [];
        this.allTenants = [];
        this.isLoaded = false;
    }
    TenantOverviewComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.tenantService.findAll().toPromise()];
                    case 1:
                        _a.allTenants = (_b.sent());
                        this.updateCurrentInfo();
                        this.isLoaded = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    TenantOverviewComponent.prototype.isSubscribed = function (tenant, role) {
        return (this.user.subscribedTenants
            .filter(function (s) { return s.tenantId === tenant.id; })
            .findIndex(function (t) { return t.role === role; }) >= 0);
    };
    TenantOverviewComponent.prototype.unsubscribe = function (tenant, role) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // NOT NEEDED?
                    // this.user = <User>(
                    return [4 /*yield*/, this.coreUserService
                            .unsubscribeUserFromTenant(tenant.id, role)
                            .toPromise()];
                    case 1:
                        // NOT NEEDED?
                        // this.user = <User>(
                        _a.sent();
                        // );
                        if (this.user.subscribedTenants.length === 0) {
                            this.loginService.generateGlobalInfo(user_1.UserRole.NONE, []).then(function () {
                                _this.roleChangeService.changeRole(user_1.UserRole.NONE);
                                _this.updateCurrentInfo();
                            });
                        }
                        else {
                            if (
                            // current role unssubscribed?
                            this.currentRole === role &&
                                this.currentTenants.length === 1 &&
                                this.currentTenants.map(function (t) { return t.id; }).indexOf(tenant.id) >= 0) {
                                this.loginService
                                    .generateGlobalInfo(this.user.subscribedTenants[0].role, [
                                    this.user.subscribedTenants[0].tenantId
                                ])
                                    .then(function () {
                                    _this.roleChangeService.changeRole(_this.user.subscribedTenants[0].role);
                                    _this.updateCurrentInfo();
                                });
                            }
                            else {
                                this.loginService
                                    .generateGlobalInfo(this.currentRole, this.currentTenants.map(function (t) { return t.id; }))
                                    .then(function () {
                                    _this.roleChangeService.update();
                                    _this.updateCurrentInfo();
                                });
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TenantOverviewComponent.prototype.subscribe = function (tenant, role) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // not needed?
                    // this.user = <User>(
                    return [4 /*yield*/, this.coreUserService
                            .subscribeUserToTenant(tenant.id, role)
                            .toPromise()];
                    case 1:
                        // not needed?
                        // this.user = <User>(
                        _a.sent();
                        // );
                        if (this.currentRole === user_1.UserRole.NONE) {
                            this.loginService.generateGlobalInfo(role, [tenant.id]).then(function () {
                                _this.roleChangeService.changeRole(role);
                                _this.updateCurrentInfo();
                            });
                        }
                        else {
                            this.loginService
                                .generateGlobalInfo(this.currentRole, this.currentTenants.map(function (t) { return t.id; }))
                                .then(function () {
                                _this.roleChangeService.update();
                                _this.updateCurrentInfo();
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TenantOverviewComponent.prototype.updateCurrentInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var globalInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loginService.getGlobalInfo().toPromise()];
                    case 1:
                        globalInfo = (_a.sent());
                        this.user = globalInfo.user;
                        this.currentTenants = globalInfo.tenants;
                        this.currentRole = globalInfo.userRole;
                        return [2 /*return*/];
                }
            });
        });
    };
    TenantOverviewComponent.prototype.navigateBack = function () {
        window.history.back();
    };
    return TenantOverviewComponent;
}());
exports.TenantOverviewComponent = TenantOverviewComponent;
